package navigation.home.service.allservice

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase
import com.essntl.features.service.domain.repository.ServiceRepository
import com.essntl.features.service.domain.use_case.ExtraCategoryServiceUseCase
import com.essntl.features.service.ui.allservice.AllServiceEvent
import com.essntl.features.service.ui.allservice.AllServiceState
import com.essntl.features.service.ui.allservice.AllServiceViewModel
import com.essntl.features.tag.domain.repository.TagRepository

class AllServiceScreenModel(
    serviceRepository: ServiceRepository,
    categoryRepository: CategoryRepository,
    tagRepository: TagRepository,
    areaRepository: AreaRepository,
    extraCategoryServiceUseCase: ExtraCategoryServiceUseCase,
    getCurrentUserUseCase: GetCurrentUserUseCase,
    loadingManager: LoadingManager,
) : StateScreenModel<AllServiceState>(AllServiceState()) {
    private val allServiceViewModel =
        AllServiceViewModel(
            serviceRepository = serviceRepository,
            extraCategoryServiceUseCase = extraCategoryServiceUseCase,
            getCurrentUserUseCase = getCurrentUserUseCase,
            categoryRepository = categoryRepository,
            tagRepository = tagRepository,
            areaRepository = areaRepository,
            scope = screenModelScope,
            state = mutableState,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AllServiceEvent) {
        allServiceViewModel.onEvent(event)
    }
}
